export interface ILogService {
    logError(error: Error, errorInfo: any): void;
}

let LogServiceType = {
    ILogService: Symbol("ILogService"),
};

export default LogServiceType;